import { createFileRoute } from "@tanstack/react-router"
import { ReveniConfiguration } from "modules/settings/components/integrations/reveni"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/reveni")({
  component: ReveniConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.reveni.title"),
    })
  },
})
